import { z } from 'zod'

export const schema = z.object({
  id: z.string(),
  picture: z.string(),
  name: z.string(),
  description: z.string(),
  answer: z
    .object({
      unit: z.string(),
      value: z.number().int(),
      range: z.string(),
      rate: z.number().int().nullable(),
    })
    .nullable(),
  acceptanceRate: z.number().int().optional().nullable(),
  legalName: z.string().optional().nullable(),
})

export type schemaType = z.infer<typeof schema>
